// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledIcon, StyledTypography } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@tps/XDL/types";
import { color, getSystemColor } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui8"),
        },
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
            `,
        },
        css: css`
            &:visited {
                color: ${color("common.ui9")};
            }
            &:disabled {
                color: ${color("primary", 0.44)};
                & ${TypographyStyle} {
                    color: ${color("primary", 0.44)};
                }
            }
            &:focus {
                outline: none;
            }
        `,
    },
} as xBaseTheme["link"];

